module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av671-5ad6e7248a8997e37e5c79b1e44d6865.jpg";